import { LanguageCode } from '@hazadapt-git/public-core-base'

export interface ZipCodeAlertTextConfig {
    title: string
    body: string
    placeholder: string
    cta: string
}

export const zipCodeAlertText: Map<LanguageCode, ZipCodeAlertTextConfig> =
    new Map<LanguageCode, ZipCodeAlertTextConfig>([
        [
            LanguageCode.ENGLISH,
            {
                title: `Confirm Zip Code`,
                body: `Your submission stays anonymous, while your efforts contribute to local community preparedness data. Thank you for doing your part!`,
                placeholder: 'Enter your ZIP code',
                cta: 'Submit',
            },
        ],
        [
            LanguageCode.SPANISH,
            {
                title: `Confirmar código postal`,
                body: `Tu envío permanece en el anonimato, mientras que tus esfuerzos contribuyen a los datos de preparación de la comunidad local. ¡Gracias por hacer tu parte!`,
                placeholder: 'Ingrese su código postal',
                cta: 'Enviar',
            },
        ],
        [
            LanguageCode.GERMAN,
            {
                title: `Postleitzahl bestätigen`,
                body: `Ihr Beitrag bleibt anonym, während Ihre Bemühungen zu den lokalen Gemeinschaftsvorsorgedaten beitragen. Danke, dass du deinen Teil dazu geleistet hast!`,
                placeholder: 'Geben Sie Ihre Postleitzahl ein',
                cta: 'Absenden',
            },
        ],
        [
            LanguageCode.FRENCH,
            {
                title: `Confirmer le code postal`,
                body: `Votre soumission reste anonyme, tandis que vos efforts contribuent aux données de préparation des communautés locales. Merci d’avoir fait ta part !`,
                placeholder: 'Entrez votre code postal',
                cta: 'Envoyer',
            },
        ],
        [
            LanguageCode.MANDARIN,
            {
                title: `确认邮政编码`,
                body: `您的提交将保持匿名，而您的努力将贡献于本地社区应急准备数据。感谢你尽一份力！`,
                placeholder: '输入您的邮政编码',
                cta: '提交',
            },
        ],
        [
            LanguageCode.RUSSIAN,
            {
                title: `Подтвердить почтовый индекс`,
                body: `Ваша публикация остаётся анонимной, а ваши усилия вносят вклад в данные о готовности местных сообществ. Спасибо, что внесли свой вклад!`,
                placeholder: 'Введите ваш почтовый индекс',
                cta: 'Отправить',
            },
        ],
        [
            LanguageCode.JAPANESE,
            {
                title: `郵便番号を確認する`,
                body: `あなたの投稿は匿名で行われ、あなたの努力は地域の準備データに貢献します。ご協力いただきありがとうございます!`,
                placeholder: '郵便番号を入力してください',
                cta: '送信',
            },
        ],
    ])
